import React, { useState } from 'react';
import './OperatorForm.css';

function OperatorForm({ mailbox, operator = null, onSubmit, onClose }) {
    const isEditing = !!operator;

    const [formData, setFormData] = useState({
        matricule: operator?.matricule || '',
        first_name: operator?.first_name || '',
        last_name: operator?.last_name || '',
        display_name: operator?.display_name || '',
        initials: operator?.initials || '',
        username: operator?.username || '',
        email: operator?.email || '',
        phone: operator?.phone || '',
        mobile: operator?.mobile || '',
        fax: operator?.fax || '',
        ip_phone: operator?.ip_phone || '',
        title: operator?.title || '',
        department: operator?.department || '',
        company: operator?.company || '',
        manager: operator?.manager || '',
        office: operator?.office || '',
        street: operator?.street || '',
        city: operator?.city || '',
        state: operator?.state || '',
        postal_code: operator?.postal_code || '',
        country: operator?.country || '',
        website: operator?.website || '',
        linkedin: operator?.linkedin || '',
        twitter: operator?.twitter || '',
        facebook: operator?.facebook || '',
        description: operator?.description || '',
        employee_id: operator?.employee_id || '',
        employee_number: operator?.employee_number || '',
        photo_url: operator?.photo_url || '',
        is_active: operator?.is_active !== undefined ? operator.is_active : true
    });

    const [loading, setLoading] = useState(false);
    const [activeSection, setActiveSection] = useState('identity');

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: type === 'checkbox' ? checked : value
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!formData.matricule || !formData.first_name || !formData.last_name) {
            alert('Matricule, prénom et nom sont requis');
            return;
        }

        setLoading(true);
        try {
            await onSubmit(formData);
        } finally {
            setLoading(false);
        }
    };

    const sections = [
        { id: 'identity', label: 'Identité', icon: 'M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z' },
        { id: 'contact', label: 'Contact', icon: 'M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z' },
        { id: 'organization', label: 'Organisation', icon: 'M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4' },
        { id: 'address', label: 'Adresse', icon: 'M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z' },
        { id: 'social', label: 'Web & Social', icon: 'M21 12a9 9 0 01-9 9m9-9a9 9 0 00-9-9m9 9H3m9 9a9 9 0 01-9-9m9 9c1.657 0 3-4.03 3-9s-1.343-9-3-9m0 18c-1.657 0-3-4.03-3-9s1.343-9 3-9m-9 9a9 9 0 019-9' },
        { id: 'other', label: 'Autres', icon: 'M5 12h.01M12 12h.01M19 12h.01M6 12a1 1 0 11-2 0 1 1 0 012 0zm7 0a1 1 0 11-2 0 1 1 0 012 0zm7 0a1 1 0 11-2 0 1 1 0 012 0z' }
    ];

    return (
        <div className="modal-overlay operator-modal-overlay" onClick={onClose}>
            <div className="operator-form-modal" onClick={e => e.stopPropagation()}>
                <div className="modal-header">
                    <h3>{isEditing ? 'Modifier l\'opérateur' : 'Nouvel opérateur'}</h3>
                    <span className="mailbox-context">pour {mailbox.email}</span>
                    <button className="modal-close" onClick={onClose}>&times;</button>
                </div>

                <form onSubmit={handleSubmit}>
                    <div className="form-layout">
                        {/* Navigation des sections */}
                        <div className="form-nav">
                            {sections.map(section => (
                                <button
                                    key={section.id}
                                    type="button"
                                    className={`nav-item ${activeSection === section.id ? 'active' : ''}`}
                                    onClick={() => setActiveSection(section.id)}
                                >
                                    <svg width="16" height="16" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d={section.icon} />
                                    </svg>
                                    {section.label}
                                </button>
                            ))}
                        </div>

                        {/* Contenu du formulaire */}
                        <div className="form-content">
                            {/* Section Identité */}
                            {activeSection === 'identity' && (
                                <div className="form-section">
                                    <div className="form-row">
                                        <div className="form-group required">
                                            <label>Matricule</label>
                                            <input
                                                type="text"
                                                name="matricule"
                                                value={formData.matricule}
                                                onChange={handleChange}
                                                placeholder="Ex: OP001"
                                                required
                                            />
                                            <span className="help-text">Code unique pour identifier l'opérateur</span>
                                        </div>
                                        <div className="form-group">
                                            <label>Actif</label>
                                            <label className="toggle-switch">
                                                <input
                                                    type="checkbox"
                                                    name="is_active"
                                                    checked={formData.is_active}
                                                    onChange={handleChange}
                                                />
                                                <span className="toggle-slider"></span>
                                            </label>
                                        </div>
                                    </div>
                                    <div className="form-row">
                                        <div className="form-group required">
                                            <label>Prénom</label>
                                            <input
                                                type="text"
                                                name="first_name"
                                                value={formData.first_name}
                                                onChange={handleChange}
                                                required
                                            />
                                        </div>
                                        <div className="form-group required">
                                            <label>Nom</label>
                                            <input
                                                type="text"
                                                name="last_name"
                                                value={formData.last_name}
                                                onChange={handleChange}
                                                required
                                            />
                                        </div>
                                    </div>
                                    <div className="form-row">
                                        <div className="form-group">
                                            <label>Nom complet</label>
                                            <input
                                                type="text"
                                                name="display_name"
                                                value={formData.display_name}
                                                onChange={handleChange}
                                                placeholder="Ex: Jean DUPONT"
                                            />
                                        </div>
                                        <div className="form-group">
                                            <label>Initiales</label>
                                            <input
                                                type="text"
                                                name="initials"
                                                value={formData.initials}
                                                onChange={handleChange}
                                                placeholder="Ex: J.D."
                                            />
                                        </div>
                                    </div>
                                    <div className="form-group">
                                        <label>Nom d'utilisateur</label>
                                        <input
                                            type="text"
                                            name="username"
                                            value={formData.username}
                                            onChange={handleChange}
                                            placeholder="Ex: jdupont"
                                        />
                                    </div>
                                </div>
                            )}

                            {/* Section Contact */}
                            {activeSection === 'contact' && (
                                <div className="form-section">
                                    <div className="form-group">
                                        <label>Email personnel</label>
                                        <input
                                            type="email"
                                            name="email"
                                            value={formData.email}
                                            onChange={handleChange}
                                            placeholder="Ex: jean.dupont@example.com"
                                        />
                                        <span className="help-text">Email de l'opérateur (différent de la boîte partagée)</span>
                                    </div>
                                    <div className="form-row">
                                        <div className="form-group">
                                            <label>Téléphone</label>
                                            <input
                                                type="tel"
                                                name="phone"
                                                value={formData.phone}
                                                onChange={handleChange}
                                                placeholder="Ex: +33 1 23 45 67 89"
                                            />
                                        </div>
                                        <div className="form-group">
                                            <label>Mobile</label>
                                            <input
                                                type="tel"
                                                name="mobile"
                                                value={formData.mobile}
                                                onChange={handleChange}
                                                placeholder="Ex: +33 6 12 34 56 78"
                                            />
                                        </div>
                                    </div>
                                    <div className="form-row">
                                        <div className="form-group">
                                            <label>Fax</label>
                                            <input
                                                type="tel"
                                                name="fax"
                                                value={formData.fax}
                                                onChange={handleChange}
                                            />
                                        </div>
                                        <div className="form-group">
                                            <label>Téléphone IP</label>
                                            <input
                                                type="text"
                                                name="ip_phone"
                                                value={formData.ip_phone}
                                                onChange={handleChange}
                                            />
                                        </div>
                                    </div>
                                </div>
                            )}

                            {/* Section Organisation */}
                            {activeSection === 'organization' && (
                                <div className="form-section">
                                    <div className="form-group">
                                        <label>Fonction / Titre</label>
                                        <input
                                            type="text"
                                            name="title"
                                            value={formData.title}
                                            onChange={handleChange}
                                            placeholder="Ex: Agent Support Niveau 2"
                                        />
                                    </div>
                                    <div className="form-row">
                                        <div className="form-group">
                                            <label>Département</label>
                                            <input
                                                type="text"
                                                name="department"
                                                value={formData.department}
                                                onChange={handleChange}
                                                placeholder="Ex: Support Client"
                                            />
                                        </div>
                                        <div className="form-group">
                                            <label>Entreprise</label>
                                            <input
                                                type="text"
                                                name="company"
                                                value={formData.company}
                                                onChange={handleChange}
                                            />
                                        </div>
                                    </div>
                                    <div className="form-row">
                                        <div className="form-group">
                                            <label>Manager</label>
                                            <input
                                                type="text"
                                                name="manager"
                                                value={formData.manager}
                                                onChange={handleChange}
                                            />
                                        </div>
                                        <div className="form-group">
                                            <label>Bureau</label>
                                            <input
                                                type="text"
                                                name="office"
                                                value={formData.office}
                                                onChange={handleChange}
                                                placeholder="Ex: Bureau 101"
                                            />
                                        </div>
                                    </div>
                                </div>
                            )}

                            {/* Section Adresse */}
                            {activeSection === 'address' && (
                                <div className="form-section">
                                    <div className="form-group">
                                        <label>Rue</label>
                                        <input
                                            type="text"
                                            name="street"
                                            value={formData.street}
                                            onChange={handleChange}
                                            placeholder="Ex: 123 Rue Example"
                                        />
                                    </div>
                                    <div className="form-row">
                                        <div className="form-group">
                                            <label>Ville</label>
                                            <input
                                                type="text"
                                                name="city"
                                                value={formData.city}
                                                onChange={handleChange}
                                            />
                                        </div>
                                        <div className="form-group">
                                            <label>Code postal</label>
                                            <input
                                                type="text"
                                                name="postal_code"
                                                value={formData.postal_code}
                                                onChange={handleChange}
                                            />
                                        </div>
                                    </div>
                                    <div className="form-row">
                                        <div className="form-group">
                                            <label>Région / État</label>
                                            <input
                                                type="text"
                                                name="state"
                                                value={formData.state}
                                                onChange={handleChange}
                                            />
                                        </div>
                                        <div className="form-group">
                                            <label>Pays</label>
                                            <input
                                                type="text"
                                                name="country"
                                                value={formData.country}
                                                onChange={handleChange}
                                            />
                                        </div>
                                    </div>
                                </div>
                            )}

                            {/* Section Web & Social */}
                            {activeSection === 'social' && (
                                <div className="form-section">
                                    <div className="form-group">
                                        <label>Site web</label>
                                        <input
                                            type="url"
                                            name="website"
                                            value={formData.website}
                                            onChange={handleChange}
                                            placeholder="Ex: www.example.com"
                                        />
                                    </div>
                                    <div className="form-group">
                                        <label>LinkedIn</label>
                                        <input
                                            type="text"
                                            name="linkedin"
                                            value={formData.linkedin}
                                            onChange={handleChange}
                                            placeholder="Ex: linkedin.com/in/jdupont"
                                        />
                                    </div>
                                    <div className="form-row">
                                        <div className="form-group">
                                            <label>Twitter</label>
                                            <input
                                                type="text"
                                                name="twitter"
                                                value={formData.twitter}
                                                onChange={handleChange}
                                                placeholder="Ex: @jdupont"
                                            />
                                        </div>
                                        <div className="form-group">
                                            <label>Facebook</label>
                                            <input
                                                type="text"
                                                name="facebook"
                                                value={formData.facebook}
                                                onChange={handleChange}
                                            />
                                        </div>
                                    </div>
                                </div>
                            )}

                            {/* Section Autres */}
                            {activeSection === 'other' && (
                                <div className="form-section">
                                    <div className="form-group">
                                        <label>Description</label>
                                        <textarea
                                            name="description"
                                            value={formData.description}
                                            onChange={handleChange}
                                            rows={3}
                                            placeholder="Description ou notes..."
                                        />
                                    </div>
                                    <div className="form-row">
                                        <div className="form-group">
                                            <label>ID Employé</label>
                                            <input
                                                type="text"
                                                name="employee_id"
                                                value={formData.employee_id}
                                                onChange={handleChange}
                                            />
                                        </div>
                                        <div className="form-group">
                                            <label>N° Employé</label>
                                            <input
                                                type="text"
                                                name="employee_number"
                                                value={formData.employee_number}
                                                onChange={handleChange}
                                            />
                                        </div>
                                    </div>
                                    <div className="form-group">
                                        <label>URL Photo</label>
                                        <input
                                            type="url"
                                            name="photo_url"
                                            value={formData.photo_url}
                                            onChange={handleChange}
                                            placeholder="Ex: https://example.com/photo.jpg"
                                        />
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>

                    <div className="modal-footer">
                        <button type="button" className="btn-secondary" onClick={onClose}>
                            Annuler
                        </button>
                        <button type="submit" className="btn-primary" disabled={loading}>
                            {loading ? 'Enregistrement...' : (isEditing ? 'Enregistrer' : 'Créer')}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
}

export default OperatorForm;
